<template>
    <div id="container">
        <template v-if="ActivityStatus===1">
            <h1>{{title}}{{ scenceId>0 && scenceTitle!==''?' - '+scenceTitle:'' }}</h1>
            <div class="games">
                <ul>
                    <template>
                        <li :class="getGameClass(game.GameId,game.Exist)" v-for="(game,index) in games" :key="index" @click="getUserList(game.GameId,game.Exist,game.GameName)"></li>
                    </template>
                </ul>
                <h3>--- {{gameName}} ---</h3>
            </div>
            <div class="result-box">
                <ul class="ul-head">
                    <li class="col1">Rank</li>
                    <li class="col2">Name</li>
                    <li class="col3">Score</li>
                    <li class="col4">Duration</li>
                    <li class="col5">District/County</li>
                </ul>
                <div class="loadingX" v-if="loading">
                    <van-loading size="36px" vertical>Loading...</van-loading>
                </div>                
                <ul class="ul-body" v-for="(user,index) in users" :key="index">
                    <li class="col1">{{user.Rank}}</li>
                    <li class="col2">{{user.RealName}}</li>
                    <li class="col3">{{user.Score}}</li>
                    <li class="col4">{{user.UseTime}}</li>
                    <li class="col5">{{user.Area}}</li>
                </ul>
                <div class="small-nothing-box" v-if="resultNothing">
                    <img src="@/assets/images/rank_nothing.png" />
                    <p>{{tips}}~</p>
                </div>
            </div>
        </template>
        <div class="nothing-box" v-if="ActivityStatus!==1">
            <img src="@/assets/images/rank_nothing.png" />
            <p>No Ongoing Competitions Now~</p>
        </div>
    </div>
</template>

<script>
import { getRankDetail,getRankList } from '@/api/index_en.js'
export default {
    name: 'RankDetail',
    props: ['id'],
    data () {
    return {
        ActivityStatus:0,   //活动状态，1:进行中，其它值均属非进行中
        activityId:0,   //活动Id
        scenceId:0,     //场次Id
        title:'',       //活动标题
        scenceTitle:'',       //场次标题
        games: [],      //游戏列表
        choosed:0,      //选中的游戏
        users:[],       //用户名单
        tips:'',        //榜单无数据时提示语
        gameName:'',     //选中的游戏名称
        loading:false,   //loading状态,
        resultNothing:false, //是否显示空查询结果
        initStatus:false    //首次加载无结果状态
    }
  },
  methods: {
    // 获取活动详情
    async initRankDetail (ActivityId,ScenceId) {
        const { data: res } = await getRankDetail(ActivityId,ScenceId)
        if (res.errcode === 0) 
        {
            this.ActivityStatus = res.data.Status
            this.title = res.data.Title
            this.scenceTitle = res.data.ScenceTitle
            this.games = res.data.Games
            this.choosed = this.games[0].GameId
            this.gameName = this.games[0].GameName

            this.getRankList(this.activityId,this.scenceId,this.choosed)
        }
        else
        {
         this.initStatus = true   
        }
    },
    // 获取榜单
    async getRankList (ActivityId,ScenceId,GameId) {
        this.loading = true
        this.resultNothing=false
        const { data: res } = await getRankList(ActivityId,ScenceId,GameId)
        if (res.errcode === 0) 
        {
            this.users = res.data
            if(this.users.length===0)
            {
                this.resultNothing = true
                this.tips = 'Please wait patiently before the list is released.'
            }
            else{
                this.resultNothing = false
                this.initStatus=false
            }
        }
        else
        {
            this.$toast('Data Acquisition Failure.')
        }
        this.loading = false
    },
    // 点击游戏项目
    getUserList(GameId,Exist,GameName)
    {
        if(Exist>0)
        {
            this.choosed = GameId
            this.users=[]
            this.getRankList(this.activityId,this.scenceId,GameId)
        }
        else
        {
            this.$toast('No This Event in the Competition.')
        }
        this.gameName = GameName
    },
    // 返回游戏项目样式
    getGameClass(GameId,Exist)
    {
        if(Exist)
        {
            if(this.choosed === GameId)
            {
                return 'selected game'+GameId
            }
            else
            {
                return 'game'+GameId
            }
        }
        else
        {
            return 'disable game'+GameId
        }
    }
  },
  created () {
    document.title = 'Real-time Results of Shanghai Citizen Jiu Zi Competition'
    this.activityId=this.$route.params.id
    this.scenceId=this.$route.params.scence
    this.initRankDetail (this.activityId,this.scenceId)

    console.log('activityId:',this.activityId)
    console.log('scenceId:',this.scenceId)
  }
}
</script>

<style>
@import url('@/assets/css_en/app.css');
</style>
<style lang="less" scoped>
#container {
    width: 100%;
    height: 100vh;
    padding: 20px 15px 45px 15px;
    box-sizing: border-box;
    background: #fff;
    overflow-y: auto;

    h1 {
        font-size: 1.2rem;
        font-size: 400;
        padding: 0;
        margin: 0 0 1rem 0;
    }

    .games {
        width: 100%;
        padding: .75rem 0 0 0;

        h3 {
            font-size: 1rem;
            font-size: 400;
            padding: 0;
            margin: .5rem 0;
            text-align: center;
            color: #ff9900;
        }

        ul,li {
            list-style: none;
            margin: 0;
            padding: 0;
        }
        ul {
            display:flex;
            flex-wrap: wrap;
            // justify-content: space-between;
        }

        li {
            width: 31%;
            height: 3.5rem;
            border-radius: 5px;
            box-sizing: border-box;
            background-color: #f1f1f1;
            background-repeat: no-repeat;
            background-position: center;
            background-size: auto 90%;
            margin:3px;
        }
        li.selected {
            background-color: #ffda96;
        }
        li.disable {
            transition: all .3s ease;
            filter: grayscale(100%);
            opacity: .6;
        }

        li.game1 {
            background-image:url(@/assets/images/game_01.png);
        }
        li.game2 {
            background-image: url(@/assets/images/game_02.png);
        }
        li.game3 {
            background-image: url(@/assets/images/game_03.png) ;
        }
        li.game4 {
            background-image: url(@/assets/images/game_04.png);
        }
        li.game5 {
            background-image: url(@/assets/images/game_05.png);
        }
        li.game6{
            background-image: url(@/assets/images/game_06.png);
        }
        li.game7 {
            background-image: url(@/assets/images/game_07.png);
        }
        li.game8 {
            background-image: url(@/assets/images/game_08.png);
        }
        li.game9 {
            background-image: url(@/assets/images/game_09.png);
        }
        li.game10 {
            background-image: url(@/assets/images/game_10.png);
        }
    }

    li.col1 {
        width: 12%;
        text-align: center;
    }
    li.col2 {
        width: 20%;
    }
    li.col3 {
        width: 19%;
    }
    li.col4 {
        width: 20%;
    }
    li.col5 {
        width: 29%;
    }

    .ul-head {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
        display: flex;
        justify-content: left;
        background: #FF9900;
        
        li {
            height: 38px;
            line-height: 38px;
            font-size: .825rem;
            font-weight: 500;
            color: #fff;
            text-align: center;
        }
    }

    .ul-body {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
        display: flex;
        justify-content: left;
        
        li {
            // height: 38px;
            // line-height: 38px;
            font-size: .75rem;
            color: #111;
            border-bottom: #eee solid 1px;
            text-align: center;
            padding:10px 0;
        }
    }

    .ul-body:nth-child(odd)
    {
        background: #f5f5f5;
    }

    .nothing-box {
        padding-top: 8rem;
        img {
            width: 90%;
            margin:0 auto;
        }
        p {
            text-align: center;
            font-size: .75rem;
            font-weight:300;
            padding: 0;
            margin: 0;
        }
    }

    .small-nothing-box {
        padding-top: 2rem;
        text-align: center;
        img {
            width: 50%;
            margin:0 auto;
        }
        p {
            text-align: center;
            font-size: .75rem;
            font-weight:300;
            padding: 0;
            margin: 0;
        }
    }

    .loadingX {
        padding: 2rem 0;

        .van-loading__text
        {
            margin-top: .75rem;
        }
    }
}
</style>